import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../components/Loader";
import ProfilePage from "./Profile/ProfilePage";
import { useTranslation } from "react-i18next";   
import { useAuth } from "../contexts/AuthProvider";
import { API_URL } from "../utils/config";
const baseUrl = API_URL;
const Profile = () => {
  const { t } = useTranslation("profile");                  // 🆕 namespace
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const path = searchParams.get("path");                    // ?path=…

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState({});
  const navigate = useNavigate();
 const { isAuthenticated } = useAuth();
  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };

  /* --------------- fetch profile --------------- */
  useEffect(() => {
    const fetchProfile = async () => {
      if (!isAuthenticated) {
        setError(new Error(t("profile.errors.noToken")));           // ⬅️ i18n
        alert(t("profile.errors.noToken"));                         // ⬅️ i18n
        navigate("/login");
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/view-profile`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            lang: getLangFromLocalStorage(),

          },
        });

        if (!res.ok) {
          if (res.status === 401) {
            navigate("/login");
            throw new Error(t("profile.errors.unauthorized"));      // ⬅️ i18n
          }
          throw new Error(`An error occurred: ${res.statusText}`);
        }

        const data = await res.json();
        setProfile(data);
        // update local storage
        localStorage.setItem("user", JSON.stringify(data?.data));
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [baseUrl, path, navigate, t]);
const samplePermissions = [
  {
    title: "View events within the venue",
    description: "Can see all events related to this venue only",
    isGranted: true
  },
  {
    title: "Edit venue details",
    description: "Can modify venue information and settings",
    isGranted: false
  }
];


  /* --------------- loading / error --------------- */
  if (loading) {
    return (
      <div className="loader-container">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <div className="venue-venues-container">
          {t("profile.errors.fetch")}: {error.message}              {/* ⬅️ i18n */}
        </div>
      </div>
    );
  }

  /* --------------- success --------------- */
  return <ProfilePage path={path} profile={profile.data}  permissions={samplePermissions} />;
};

export default Profile;
